import { useMemo } from 'react';

import { DateTime } from 'luxon';
import { InfoListCard } from 'ui';

type PdfInfoBoxProps = {
  eventStartDate?: string;
  eventLocation?: string;
};

const PdfInfoBox = ({ eventStartDate, eventLocation }: PdfInfoBoxProps) => {
  const _eventDate = useMemo(
    () =>
      eventStartDate
        ? DateTime.fromISO(eventStartDate).toLocaleString({
            ...DateTime.DATE_MED,
          })
        : undefined,
    [eventStartDate]
  );
  const _eventTime = useMemo(
    () =>
      eventStartDate
        ? DateTime.fromISO(eventStartDate).toLocaleString({ ...DateTime.TIME_SIMPLE })
        : undefined,
    [eventStartDate]
  );
  if (!_eventDate || !_eventTime) return null;

  return (
    <InfoListCard color="blue">
      <InfoListCard.Item label="Date:" detail={_eventDate} />
      <InfoListCard.Item label="Time:" detail={_eventTime} />
      <InfoListCard.Item label="Location:" detail={eventLocation} />
    </InfoListCard>
  );
};

export { PdfInfoBox };
